import { realBricksApi } from '../../utils/axiosInterceptors';

export const getFAQs = async (data = {}, { rejectWithValue }) => {
  const { onFail = () => {} } = data;
  try {
    const response = await realBricksApi.get(`/api/v1/faq?page=1&perPage=200`);
    return response.data;
  } catch (err) {
    onFail();
    return rejectWithValue(err?.response?.data?.message);
  }
};
